<!-- 百度地图 -->
<template>
<div class="info-block">
  <div class="info-detail-content">
    <iframe width="1136" height="392" frameborder="0" :src="'https://www.sxl.cn/c/apps/baidu_map/'+info.region"></iframe>
  </div>
</div>
</template>
<script>
export default {
  name: 'BdMap',
  props: {
    info: {
      type: Object,
      default: function(){return {}}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:content-box;
  height:280px;
  padding:0px;
  margin:0px 0px 10px 0px;
  //background-color:green;
}

.info-block .info-block-a:hover{
  border:1px solid orange;
  box-shadow:0px 0px 1px 1px orange;
}

.info-detail-content{
  position:relative;
  margin-top:20px;
  background-color:#eee;
  border-radius:2px;
  background-color:rgba(255,255,255,0.6);
}

.info-detail-content p{
  padding:10px;
  font-size:14px;
  font-weight:0;
  text-align: justify;
  text-indent:2em;
  line-height:40px;
  letter-spacing:0px;
  font-family: Arial,"PingFang SC","Hiragino Sans GB",STHeiti,"Microsoft YaHei","WenQuanYi Micro Hei",sans-serif;
  color:#333;
}
</style>



// WEBPACK FOOTER //
// src/components/module/BdMap.vue